<div class="row">
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<video width="100%" height="auto" controls autoplay>
			  <source src="https://app.mysleeptutor.com/assets/what_perpetuates_insomnia.mp4" type="video/mp4">
			Your browser does not support the video tag.
			</video>
		</div>
	<div class="col-md-2"></div>
</div>
<br>

<p style="color : #002E46 !important;">
    There is a variety of habits that can hurt our sleep without us even knowing it. For example:

</p>
<br>


<ul class="ion-text-left" style="margin-left: 5%;">
    <li style="color : #002E46 !important;">
        Using the bedroom for activities other than sleeping and intimacy
    </li>
    <li style="color : #002E46 !important;">
        Constantly worrying in bed
    </li>
    <li style="color : #002E46 !important;">
        Use of stimulants such as caffeine, tea or energy drinks
    </li>
    <li style="color : #002E46 !important;">
        Use of substances that fragment sleep such as alcohol
    </li>
    <li style="color : #002E46 !important;">
        Using electronic devices in bed prior to sleep
    </li>

</ul>

<br>
<p style="color : #002E46 !important;">
    We also need to make sure our bedroom is conducive to sleep.
</p>
<br>

<mat-accordion class="example-headers-align" multi="false">


    <!---->
    <mat-expansion-panel class="ion-text-left">

        <mat-expansion-panel-header>
            <mat-panel-title style="font-weight: bold; color : #002E46 !important;">
                THE EFFECTS OF NEGATIVE SLEEP THOUGHTS
            </mat-panel-title>

        </mat-expansion-panel-header>


        <p style="color : #002E46 !important;">
            Negative sleep thoughts can also have a profound adverse effect on sleep. Some of the following may sound
            very familiar to some of you. Statements like:

        </p>
        <br>


        <ul class="ion-text-left" style="margin-left: 5%;">
            <li style="color : #002E46 !important;">
                I didn’t sleep a wink last night
            </li>
            <li style="color : #002E46 !important;">
                I must get 8 hours of sleep
            </li>
            <li style="color : #002E46 !important;">
                My insomnia is going to cause health problems
            </li>
            <li style="color : #002E46 !important;">
                I'm not going to have a good sleep tonight
            </li>
            <li style="color : #002E46 !important;">
                I don’t feel well because I didn’t sleep well
            </li>
            <li style="color : #002E46 !important;">
                I can’t sleep without a sleeping pill
            </li>

        </ul>


        <p style="color : #002E46 !important;">
            On the surface, all these thoughts seem like a normal reaction to insomnia. However, the only purpose they
            serve is to make it more difficult for one to fall asleep.

        </p>
        <br>

        <p style="color : #002E46 !important;">
            All negative thoughts, whether they occur while awake, at bedtime, or in the middle of the night, tend to
            make you feel anxious and frustrated, which in turn mobilizes the stress response, increasing your heart
            rate, blood pressure, muscle tension, breathing rate, and, most importantly, activates your brain.
        </p>
        <br>
        <p style="color : #002E46 !important;">
            Here are some of the common thoughts that can negatively affect one’s sleep and some examples of how one can
            re-construct these thoughts into something constructive.

        </p>

        <br>
        <table style="width:100%">
            <tr>
                <th style="color : #002E46 !important;">
                    NEGATIVE THOUGHTS
                </th>
                <th style="color : #002E46 !important;">
                    POSITIVE THOUGHTS
                </th>
            </tr>
            <tr>
                <td style="color : #002E46 !important;">Oh no! I am still awake </td>
                <td style="color : #002E46 !important;">I need less sleep than I thought to function</td>

            </tr>
            <tr>
                <td style="color : #002E46 !important;">This is another sleepless night </td>
                <td style="color : #002E46 !important;">I always fall asleep sooner or later</td>

            </tr>
            <tr>
                <td style="color : #002E46 !important;">I don’t think I can fall to sleep</td>
                <td style="color : #002E46 !important;">Let’s focus on breathing and relaxation to help me fall to asleep
                </td>

            </tr>

        </table>
        <br>
        <p style="color : #002E46 !important;">
            Here are some examples of behaviors or habits that affect our sleep:

        </p>
        <br>
        <p style="color : #002E46 !important;">
            <strong> Negative habit: </strong>
            using caffeine or energy drinks to boost energy, excessive worrying while in bed, watching TV or using
            electronics in bed, using the bedroom for purposes other than sleep and intimacy, and using of alcohol to
            fall asleep.

        </p>
        <br>
        <p style="color : #002E46 !important;">
            <strong> Positive habits: </strong>
            engaging in exercise throughout the day to help with improving energy, making our sleep environment
            comfortable, having a regular sleep routine, using the bedroom only for sleep, and limiting the use of
            stimulants.
        </p>
        <br>
        <p style="color : #002E46 !important;">
            Can you think of other (current or past) habits and thoughts that hurt your sleep?
            <br>Create your own list of habits that negatively affect your sleep and come up with a more constructive
            solution for each.
        </p>

        <br>

        <mat-card style="background-color: #e9f3f1;">
            <mat-card-content>
                <mat-card-header>
                    <mat-card-title style="font-weight: bold; color : #002E46 !important;" class="ion-text-center">Key Points
                    </mat-card-title>

                </mat-card-header>


                <p style="color : #002E46 !important;">
                    It is important to recognize the negative thoughts and behaviors that hurt your sleep, but it is
                    equally if not more important to implement and reinforce the practices that help your sleep, and
                    that you use these behaviors to modify and replace the practices that hurt it.
                </p>
                <br>



            </mat-card-content>
        </mat-card>




    </mat-expansion-panel>
    <!---->
</mat-accordion>